// UpdateEmail.jsx
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Auth } from 'aws-amplify';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';
import { View, TextField, Divider } from '@aws-amplify/ui-react';

export const UpdateEmail = (props) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  //更新後のアカウント情報を入れる変数
  const [editedUser, setEditedUser] = useState(props.userinfo);


  async function updateUserEmail(wk_email) {
    try {
      //スピナーを表示
      setLoading(true)

      const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
      await Auth.updateUserAttributes(user, {
        email: wk_email
      });

      //console.log('a verification code is sent');
    } catch (err) {
      console.log('failed with error', err);
    } finally {
      //スピナーを非表示
      setLoading(false)
    }
  }

  async function signOut() {
    try {
      await Auth.signOut();
      alert("メールアドレスを変更しました。ログアウトします。")
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  async function verifyEmailValidationCode(code) {
    try {
      await Auth.verifyCurrentUserAttributeSubmit('email', code);
      console.log('email verified');
      //確認コードが確認できたら、サインアウトする
      signOut();
    } catch (err) {
      console.log('failed with error', err);
      alert("メールアドレスの変更ができませんでした。確認コードが間違っているか、既に登録されているメールアドレスです。")
    }
  }

  function ValidationCodeForm() {
    const [validationCode, setValidationCode] = useState(null);
    return (
      <>
        <TextField label="確認コードを入力（変更後のメールアドレスに送付）"
          onChange={(e) => {
            setValidationCode(e.target.value);
          }}
        />
        <Button variant="primary" onClick={() => {
          verifyEmailValidationCode(validationCode);
        }} style={{ marginTop: "10px" }}>
          確認
        </Button>
      </>
    );
  }

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [showValidationCodeUI, setShowValidationCodeUI] = useState(false);
  return (
    <>
      <View className="d-flex flex-column align-items-center">
        <Button
          variant="outline-primary"
          size="sm"
          onClick={handleShow}
          style={{ margin: "10px auto" }}
        >
          メールアドレスの変更
        </Button>
      </View>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>メールアドレスの変更</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="fs-6">
            コードを送信ボタンを押すと、変更後のメールアドレスに確認コードが送信されます。
            <br />
            確認コードを入力し、確認ボタンを押すと、メールアドレスが変更されます。
            <br />
            一度、自動的にログアウトされますので、変更後のメールアドレスで再度ログインしてください。
          </p>

          <Authenticator>
            {({ signOut, user }) => (
              <div>
                {showValidationCodeUI === false && (
                  <>
                    <Divider orientation="horizontal" />
                    <p>現在のメールアドレス</p>
                    <p className="text-start">{props.userinfo.email}</p>
                    <Divider orientation="horizontal" />
                    <TextField
                      label="変更後のメールアドレス"
                      defaultValue={editedUser.email}
                      onChange={(event) => {
                        setEditedUser((prevState) => ({
                          ...prevState,
                          email: event.target.value,
                        }));
                      }}
                    ></TextField>
                    <Button
                      variant="primary"
                      disabled={loading}
                      onClick={async () => {
                        await updateUserEmail(editedUser.email);
                        setShowValidationCodeUI(true);
                      }}
                      style={{ marginTop: "10px", marginBottom: "10px" }}
                    >
                      {" "}
                      {loading ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : null}
                      コードを送信
                    </Button>
                  </>
                )}

                <Divider orientation="horizontal" />
                {showValidationCodeUI === true && <ValidationCodeForm />}
                <p>
                  {showValidationCodeUI === true && (
                    <Button
                      variant="secondary"
                      size="sm"
                      style={{ marginTop: "10px", marginBottom: "10px" }}
                      onClick={() => {
                        setShowValidationCodeUI(false);
                      }}
                    >
                      メールアドレスを修正する
                    </Button>
                  )}
                </p>
              </div>
            )}
          </Authenticator>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="link" onClick={handleClose}>
            キャンセル
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}